import { type AssociationType } from '@/portal-api.definition';
import { ChevronRight, Email, Loader, Smartphone } from '@nosinovacao/fe-icons';
import { Captcha, If, ListItem, useI18n } from '@nosinovacao/nosid-mfe-common';
import { type JSX } from 'react';
import { type ContactSelectionProps } from '../../-model/props';

const iconForOption: Record<AssociationType, JSX.Element> = {
  Phone: <Smartphone width={24} height={24} />,
  Email: <Email width={24} height={24} />,
  Nif: <></>,
  Passport: <></>,
};

export function ContactSelectionLight({
  contacts,
  loadingContact,
  captchaChallenge,
  onCaptchaChange,
  onContactSelected,
}: Readonly<ContactSelectionProps>) {
  const { t } = useI18n();
  return (
    <div className="flex size-full flex-col gap-4">
      {contacts.map((contact) => (
        <ListItem
          disabled={loadingContact !== null}
          key={contact.Id}
          skin="light"
          title={t(`Services.AddServices.ContactSelection.${contact.Type}`)}
          leadingIcon={iconForOption[contact.Type]}
          onClick={() => onContactSelected(contact.Id, contact.Type)}
          trailingIcon={
            loadingContact === contact.Type ? (
              <Loader height={24} width={24} />
            ) : (
              <ChevronRight width={24} height={24} />
            )
          }
          data-tid={`button-${contact.Type.toLowerCase()}`}
        />
      ))}
      <If condition={captchaChallenge}>
        <Captcha onChange={onCaptchaChange} />
      </If>
    </div>
  );
}
